// import Fancybox from "@/utils/fancybox.js";
export default function (element, data) {
    element.querySelector('.video__link').addEventListener('click', async function(e) {
        // e.preventDefault();
        let imageBlock = element.querySelector('.media__block_image');
        let btnElement = element.querySelector('.video__link');
        // let videoBlock = element.querySelector('.video__block');
        let video = element.querySelector("video");
        let videoBlock = element.querySelector(".video-block");
        
        videoBlock.classList.remove('hidden');
        imageBlock.classList.add('hidden');
        btnElement.classList.add('hidden');

        // let videoLink = videoBlock.dataset.videoBlock;

        // videoBlock.innerHTML = `
        //     <iframe width="560" height="315"
        //         src="${videoLink}?autoplay=1"
        //         frameborder="0"
        //         allow="autoplay; encrypted-media"
        //         allowfullscreen>
        //     </iframe>`;

        if (video) {
            video.muted = false;
            video.controls = true;
            video.loop = false;
            video.play();
        }
    });

}